import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import gsap from 'gsap'
import GUI from 'lil-gui'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js';
// import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
// import { TTFLoader } from 'three/examples/jsm/Addons.js';


// Load the font
/**
 * Debug UI
 */ 
let hoveredMesh = null;
const canvas = document.querySelector('canvas.webgl');
const scene = new THREE.Scene();
const renderer = new THREE.WebGLRenderer({ canvas });
const gui = new GUI({ width: 300, title: "Nice Debug UI", closeFolders: true });
let ryanMesh, bMesh, creativeMesh;
const clickableTexts = [];

gui.domElement.style.display = 'none';

window.addEventListener('keydown', (event) => {
    if (event.key === 'h') {
        gui.domElement.style.display = (gui.domElement.style.display === 'none') ? 'block' : 'none';
    }
});

const debugMag = {};

const loader = new FontLoader();
loader.load('./Our Arcade Games_Regular.json', (font) => {
    // === RYAN ===
    const ryanGeometry = new TextGeometry("Ryan", { font, size: 0.5, depth: 0.2, bevelEnabled: true, bevelThickness: 0.02, bevelSize: 0.02, bevelSegments: 5 });
    ryanGeometry.computeBoundingBox();
    ryanGeometry.translate(-0.5, 0, 0);

    const matcapRyan = new THREE.MeshMatcapMaterial({ matcap: new THREE.TextureLoader().load('./matcapGreen.png') });
    const ryanMesh = new THREE.Mesh(ryanGeometry, matcapRyan);
    ryanMesh.position.set(-3, 1.5, -1);
    scene.add(ryanMesh);
    clickableTexts.push({ mesh: ryanMesh, url: './Ryan.html' });

    // === B ===
    const bGeometry = new TextGeometry("B", { font, size: 0.5, depth: 0.2, bevelEnabled: true, bevelThickness: 0.02, bevelSize: 0.02, bevelSegments: 5 });
    bGeometry.computeBoundingBox();
    bGeometry.translate(-0.25, 0, 0);

    const matcapB = new THREE.MeshMatcapMaterial({ matcap: new THREE.TextureLoader().load('./matcapPink2.png') });
    const bMesh = new THREE.Mesh(bGeometry, matcapB);
    bMesh.position.set(-0.6, 1.5, -1);
    scene.add(bMesh);
    clickableTexts.push({ mesh: bMesh, url: './B.html' });

    // === CREATIVE ===
    const creativeGeometry = new TextGeometry("Creative", { font, size: 0.5, depth: 0.2, bevelEnabled: true, bevelThickness: 0.02, bevelSize: 0.02, bevelSegments: 5 });
    creativeGeometry.computeBoundingBox();
    creativeGeometry.translate(-1, 0, 0);

    const matcapCreative = new THREE.MeshMatcapMaterial({ matcap: new THREE.TextureLoader().load('./matcapBlue4.png') });
    const creativeMesh = new THREE.Mesh(creativeGeometry, matcapCreative);
    creativeMesh.position.set(1.2, 1.5, -1);
    scene.add(creativeMesh);
    clickableTexts.push({ mesh: creativeMesh, url: './creative.html' });

    // === GUI for positioning Ryan/B/Creative ===
    const textFolder = gui.addFolder('Text Position');
    textFolder.add(ryanMesh.position, 'x', -10, 10).step(0.1).name('Ryan X');
    textFolder.add(ryanMesh.position, 'y', -10, 10).step(0.1).name('Ryan Y');
    textFolder.add(ryanMesh.position, 'z', -10, 10).step(0.1).name('Ryan Z');

    textFolder.add(bMesh.position, 'x', -10, 10).step(0.1).name('B X');
    textFolder.add(bMesh.position, 'y', -10, 10).step(0.1).name('B Y');
    textFolder.add(bMesh.position, 'z', -10, 10).step(0.1).name('B Z');

    textFolder.add(creativeMesh.position, 'x', -10, 10).step(0.1).name('Creative X');
    textFolder.add(creativeMesh.position, 'y', -10, 10).step(0.1).name('Creative Y');
    textFolder.add(creativeMesh.position, 'z', -10, 10).step(0.1).name('Creative Z');

    // === Cube face labels ===
    const faceLabels = [
        { text: ['Graphic', 'Design'], position: { x: 0.5, y: 0, z: 0 }, rotation: { x: 0, y: 1.5, z: 0 }, color: 0x4a1c4d },
        { text: ['Acting'], position: { x: -0.5, y: 0, z: 0 }, rotation: { x: 0, y: -Math.PI / 2, z: 0 }, color: 0x124669 },
        { text: ['Video', 'Creation'], position: { x: 0, y: 0.55, z: 0 }, rotation: { x: -1.54, y: 0, z: 0 }, color: 0x686905 },
        { text: ['Web', 'Design'], position: { x: 0, y: -0.5, z: 0 }, rotation: { x: -Math.PI / 2, y: Math.PI, z: -Math.PI }, color: 0x864d01 },
        { text: ['Marketing'], position: { x: 0, y: 0, z: 0.57 }, rotation: { x: Math.PI * 2, y: 0, z: 0 }, color: 0x136d47 },
        { text: ['3D Design'], position: { x: 0, y: 0, z: -0.5 }, rotation: { x: 0, y: Math.PI, z: 0 }, color: 0x5D1309 }
    ];
    
    const faceLabelGroups = [];

    // faceLabels.forEach(({ text, position, rotation, color }) => {
    //     const group = new THREE.Group();
    //     const lineHeight = 0.2;
    //     const totalHeight = (text.length - 1) * lineHeight;

    //     text.forEach((line, i) => {
    //         const geo = new TextGeometry(line, { font, size: 0.08, depth: 0.02, bevelEnabled: true, bevelThickness: 0.002, bevelSize: 0.002, bevelSegments: 3 });
    //         geo.computeBoundingBox();
    //         const bbox = geo.boundingBox;
    //         geo.translate(-(bbox.max.x + bbox.min.x) / 2, -(bbox.max.y + bbox.min.y) / 2, 0);

    //         const mat = new THREE.MeshStandardMaterial({ color });
    //         const mesh = new THREE.Mesh(geo, mat);
    //         mesh.position.y = totalHeight / 2 - i * lineHeight;
    //         group.add(mesh);
    //     });

    //     group.position.set(position.x, position.y, position.z);
    //     group.rotation.set(rotation.x, rotation.y, rotation.z);
    //     scene.add(group);

    faceLabels.forEach(({ text, position, rotation, color }, index) => {
        const group = new THREE.Group();
        const lineHeight = 0.2;
        const totalHeight = (text.length - 1) * lineHeight;
    
        text.forEach((line, i) => {
            const geo = new TextGeometry(line, {
                font,
                size: 0.08,
                depth: 0.02,
                bevelEnabled: true,
                bevelThickness: 0.002,
                bevelSize: 0.002,
                bevelSegments: 3
            });
    
            geo.computeBoundingBox();
            const bbox = geo.boundingBox;
            geo.translate(-(bbox.max.x + bbox.min.x) / 2, -(bbox.max.y + bbox.min.y) / 2, 0);
    
            const mat = new THREE.MeshStandardMaterial({ color });
            const mesh = new THREE.Mesh(geo, mat);
            mesh.position.y = totalHeight / 2 - i * lineHeight;
            group.add(mesh);
        });

        group.position.set(position.x, position.y, position.z);
        group.rotation.set(rotation.x, rotation.y, rotation.z);
        scene.add(group);
    
        // ✅ Track group for hover + click
        faceLabelGroups.push(group);
        clickableTexts.push({ mesh: group, url: faceURLs[index] });
        const folder = gui.addFolder(text.join(' '));
        folder.add(group.position, 'x', -2, 2, 0.01).name('X');
        folder.add(group.position, 'y', -2, 2, 0.01).name('Y');
        folder.add(group.position, 'z', -2, 2, 0.01).name('Z');
        folder.add(group.rotation, 'x', -Math.PI, Math.PI, 0.01).name('Rot X');
        folder.add(group.rotation, 'y', -Math.PI, Math.PI, 0.01).name('Rot Y');
        folder.add(group.rotation, 'z', -Math.PI, Math.PI, 0.01).name('Rot Z');
    });
});

// Raycaster click logic
const raycaster = new THREE.Raycaster();
const mouse = new THREE.Vector2();

window.addEventListener('click', (event) => {
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
    raycaster.setFromCamera(mouse, camera);
    const intersects = raycaster.intersectObjects(clickableTexts.map(o => o.mesh));
    if (intersects.length > 0) {
        const match = clickableTexts.find(obj => obj.mesh === intersects[0].object);
        if (match) {
            window.location.href = match.url;
        }
    }
});

/**
 * Cube with Different Face Colors
 */
let geometry = new THREE.BoxGeometry(1, 1, 1);
geometry.deleteAttribute('uv'); // Remove UVs since we aren't using textures
geometry= geometry.toNonIndexed(); // Converts to non-indexed to avoid shared vertices

const colors = new Float32Array(geometry.attributes.position.count * 3); // Color array

// Define solid colors for the six faces
const faceColors = [
    new THREE.Color(0xDDC5E7), // Green
    new THREE.Color(0xB7DBF3), // Blue
    new THREE.Color(0xFAEBA6), // yellow
    new THREE.Color(0xF6D2AE), // organe
    new THREE.Color(0xB5EECD), // purp //0xB5EECD
    new THREE.Color(0xF8C1BA)  // red
];

// Apply colors (Each face has 2 triangles, 6 vertices)
for (let i = 0; i < 6; i++) {
    const color = faceColors[i];
    for (let j = 0; j < 6; j++) { // Each face has 6 vertices
        colors[(i * 18) + (j * 3)] = color.r;
        colors[(i * 18) + (j * 3) + 1] = color.g;
        colors[(i * 18) + (j * 3) + 2] = color.b;
    }
}

geometry.setAttribute('color', new THREE.BufferAttribute(colors, 3));

const material = new THREE.MeshBasicMaterial({ vertexColors: true });
const mesh = new THREE.Mesh(geometry, material);
scene.add(mesh);

/**
 * Debug Controls
 */
const cubeTweaks = gui.addFolder('Awesome Cube');
cubeTweaks.add(mesh.position, 'y').min(-3).max(3).step(0.1).name('elevation');
cubeTweaks.add(mesh, 'visible');
cubeTweaks.add(material, 'wireframe');
debugMag.spin = () => {
    gsap.to(mesh.rotation, { y: mesh.rotation.y + Math.PI * 2 });
};
cubeTweaks.add(debugMag, 'spin');

/**
 * Sizes
 */
const sizes = { width: window.innerWidth, height: window.innerHeight };

window.addEventListener('resize', () => {
    sizes.width = window.innerWidth;
    sizes.height = window.innerHeight;

    camera.aspect = sizes.width / sizes.height;
    camera.updateProjectionMatrix();

    renderer.setSize(sizes.width, sizes.height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

/**
 * Camera
 */
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 1000);
camera.position.set(1.5, 1.5, 3.5);
scene.add(camera);

// Controls
// const controls = new OrbitControls(camera, canvas);
// controls.enableDamping = true;
const controls = new OrbitControls(camera, canvas);
controls.enableDamping = true;

// Add lighting for better visibility
// const ambientLight = new THREE.AmbientLight(0x444444); // Soft ambient light
// scene.add(ambientLight);

const ambientLight = new THREE.AmbientLight(0xffffff, 0.6); // color, intensity
scene.add(ambientLight);

/**
 * Renderer
 */
// const renderer = new THREE.WebGLRenderer({ canvas });
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

// const raycaster = new THREE.Raycaster();
// const mouse = new THREE.Vector2();

// Define URLs for each face


/* 
Background?
*/
let starYGeo, starsY; 

starYGeo =  new THREE.BufferGeometry();

let starYVertices = [];
for(let i=0;i<4000;i++){
    let starY = new THREE.Vector3(
        Math.random() * 600 - 300, 
        Math.random() * 600 - 300, 
        Math.random() * 600 - 300
    );
    starY.velocity = 0;
    starY.acceleration = 1;
    starYVertices.push(starY.x, starY.y, starY.z); 
}

starYGeo.setAttribute('position', new THREE.Float32BufferAttribute(starYVertices, 3));

let spriteY = new  THREE.TextureLoader().load('whiteCircle.png')
let starYMaterial = new THREE.PointsMaterial({
    color: 0xc5ae5f,
    size: 0.7,
    map: spriteY
})

 // Render before everything else
starsY = new THREE.Points(starYGeo, starYMaterial); 
starsY.renderOrder = -1;
scene.add(starsY);


let starWGeo, starsW; 

starWGeo =  new THREE.BufferGeometry();

let starWVertices = [];
for(let i=0;i<4000;i++){
    let starW = new THREE.Vector3(
        Math.random() * 600 - 300, 
        Math.random() * 600 - 300, 
        Math.random() * 600 - 300
    );
    starW.velocity = 0;
    starW.acceleration = 1;
    starWVertices.push(starW.x, starW.y, starW.z); 
}

starWGeo.setAttribute('position', new THREE.Float32BufferAttribute(starWVertices, 3));

let spriteW = new  THREE.TextureLoader().load('whiteCircle.png')
let starWMaterial = new THREE.PointsMaterial({
    color: 0xFFFFFF,
    size: 0.7,
    map: spriteW
})

 // Render before everything else
starsW = new THREE.Points(starWGeo, starWMaterial); 
starsW.renderOrder = -1;
scene.add(starsW);



/*
Clickable 
*/

const faceURLs = [
    './GraphicDesign.html', // Red face
    './Acting.html', // Green face
    './VideoCreation.html', // Blue face
    './WebDesign.html', // Yellow face
    './Marketing.html', // Magenta face
    './ThreeD.html',  // Cyan face
];




// Handle click events
window.addEventListener('mousemove', (event) => {
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

    raycaster.setFromCamera(mouse, camera);
    const intersects = raycaster.intersectObjects(clickableTexts.map(obj => obj.mesh), true); // 👈 true = recursive

    if (intersects.length > 0) {
        canvas.style.cursor = 'pointer';
    } else {
        canvas.style.cursor = 'default';
    }
});

window.addEventListener('dblclick', (event) => {
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

    raycaster.setFromCamera(mouse, camera);

    const clickableObjects = clickableTexts.map(item => item.mesh);
    clickableObjects.push(mesh); // Add cube

    // ✅ Recursive = true so we can detect children of groups
    const intersects = raycaster.intersectObjects(clickableObjects, true);

    if (intersects.length > 0) {
        const hit = intersects[0].object;

        // ✅ Look for the parent group if hit is part of a face label group
        const clickedText = clickableTexts.find(item =>
            item.mesh === hit || (item.mesh.children && item.mesh.children.includes(hit))
        );

        if (clickedText) {
            window.location.href = clickedText.url;
            return;
        }

        // Cube logic
        if (hit === mesh) {
            const faceIndex = Math.floor(intersects[0].faceIndex / 2);
            if (faceURLs[faceIndex]) {
                window.location.href = faceURLs[faceIndex];
            }
        }
    }
});
/*
MOBILE
*/

const isMobile = window.innerWidth <= 800; // You can adjust this breakpoint to suit your needs

if (isMobile) {
    let lastTap = 0;

    window.addEventListener('touchstart', (event) => {
        const currentTap = new Date().getTime();
        const tapDifference = currentTap - lastTap;

        // Check if it's a double-tap (within 300 ms)
        if (tapDifference < 300 && tapDifference > 0) {
            // Normalize touch position (-1 to +1 range)
            const touch = event.touches[0];
            mouse.x = (touch.clientX / window.innerWidth) * 2 - 1;
            mouse.y = -(touch.clientY / window.innerHeight) * 2 + 1;

            // Raycasting
            raycaster.setFromCamera(mouse, camera);
            const intersects = raycaster.intersectObject(mesh);

            if (intersects.length > 0) {
                // Get the intersected face index (each face has two triangles)
                const faceIndex = Math.floor(intersects[0].faceIndex / 2);

                // Open corresponding URL
                if (faceURLs[faceIndex]) {
                    window.location.href = faceURLs[faceIndex];
                }
            }
        }

        lastTap = currentTap; // Store the time of the current tap
    });
}
/**
 * Animate
 */

const clock = new THREE.Clock();
const tick = () => {
    controls.update();
    // starGeo.vertices.forEach(p=>{
    //     p.velocity += p.acceleration;
    //     p.y -+ p.velocity;
    //     if (p.y <-200) {
    //         p.y = 200;
    //         p.velocity = 0;
    //     }
    // })
    // starGeo.verticesNeedUpdate = true;
    // stars.rotation.y += 0.002;
    // renderer.render(scene, camera);
    // window.requestAnimationFrame(tick);
    const positions = starYGeo.attributes.position.array;
    for (let i = 0; i < positions.length; i += 3) {
        // Retrieve the current star position
        let p = { 
            x: positions[i], 
            y: positions[i + 1], 
            z: positions[i + 2] 
        };

        // Initialize velocity and acceleration if not defined
        if (!p.velocity) p.velocity = 0;
        if (!p.acceleration) p.acceleration = 0.001; // Define acceleration if not set

        // Update position and velocity
        p.velocity += p.acceleration;
        p.y += p.velocity;

        // Reset position when it goes below a threshold
        if (p.y < -200) {
            p.y = 200;
            p.velocity = 0;
        }

        // Set the updated values back to the positions array
        positions[i + 1] = p.y;
    }

    // Mark the position buffer for an update
    starYGeo.attributes.position.needsUpdate = true;

    // Rotate stars slightly
    starsY.rotation.y += 0.0002;


    const positionsW = starWGeo.attributes.position.array;
    for (let i = 0; i < positionsW.length; i += 3) {
        // Retrieve the current star position
        let p = { 
            x: positions[i], 
            y: positions[i + 1], 
            z: positions[i + 2] 
        };

        // Initialize velocity and acceleration if not defined
        if (!p.velocity) p.velocity = 0;
        if (!p.acceleration) p.acceleration = 0.001; // Define acceleration if not set

        // Update position and velocity
        p.velocity += p.acceleration;
        p.y += p.velocity;

        // Reset position when it goes below a threshold
        if (p.y < -200) {
            p.y = 200;
            p.velocity = 0;
        }

        // Set the updated values back to the positions array
        positionsW[i + 1] = p.y;
    }

    // Mark the position buffer for an update
    starWGeo.attributes.position.needsUpdate = true;

    // Rotate stars slightly
    starsW.rotation.y += 0.0002;





    

    // Render the scene
    renderer.render(scene, camera);

    // Call the next frame
    window.requestAnimationFrame(tick);
};

tick();
